import { SvrConn } from "../utils/axios/index";

//----------------------------------------------------------------------------------------------------------------------
const getUserxId = async () => {
  let res = {};
  try {
    res = await SvrConn.get("/api/users/getParamsUser");
  } catch (Error) {
    res = Error;
  }
  return res;
};

//----------------------------------------------------------------------------------------------------------------------
const getUsuarioFind = async (query) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/users/getusuariofind",{query});
  } catch (Error) {
    res = Error;
  }
  return res;
};

//----------------------------------------------------------------------------------------------------------------------
const getUserAll = async () => {
  let res = {};
  try {
    res = await SvrConn.get("/api/users/getuserall");
  } catch (Error) {
    res = Error;
  }
  return res;
};
//----------------------------------------------------------------------------------------------------------------------
const getUserImport = async () => {
  let res = {};
  try {
    res = await SvrConn.get("/api/users/getuserImport");
  } catch (Error) {
    res = Error;
  }
  return res;
};


//----------------------------------------------------------------------------------------------------------------------
const getPermisUserRuta = async (Ruta) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/users/getpermuserruta",{Ruta});
  } catch (Error) {
    res = Error;
  }
  return res;
};

//----------------------------------------------------------------------------------------------------------------------
const getUserPermission = async (UsuarioId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/users/getuserpermission",{UsuarioId});
  } catch (Error) {
    res = Error;
  }
  return res;
};

//----------------------------------------------------------------------------------------------------------------------
const setUserPermission = async(UsuarioId, frmData)=>{
  let res = {};
    try {
      res = await SvrConn.post("/api/users/setuserpermission", {UsuarioId, frmData});
    } catch (Error) {
      res = Error;
    }
    return res;
}

//----------------------------------------------------------------------------------------------------------------------
const getUserInt = async (UsuarioId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/users/getuserint",{UsuarioId});
  } catch (Error) {
    res = Error;
  }
  return res;
};

//----------------------------------------------------------------------------------------------------------------------
const getFindUserParams = async (numeronit, nombreusr, estado) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/users/getfinduserparams",{numeronit, nombreusr, estado});
  } catch (Error) {
    res = Error;
  }
  return res;
};

//----------------------------------------------------------------------------------------------------------------------
const getFindUserIdParams = async (UsuarioId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/users/getUserInt",{UsuarioId});
  } catch (Error) {
    res = Error;
  }
  return res;
};

//----------------------------------------------------------------------------------------------------------------------
const ActualizaUser = async (datas) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/users/setactualizauser", datas);
  } catch (Error) {
    res = Error;
  }
  return res;
};

//----------------------------------------------------------------------------------------------------------------------
const ActualizaClave = async (data) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/users/setactualizapassword", data);
  } catch (Error) {
    res = Error;
  }
  return res;
};

//----------------------------------------------------------------------------------------------------------------------
const getFindUserApi = async (numeronit, nombreusr) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/users/getfinduserapi",{numeronit, nombreusr});
  } catch (Error) {
    res = Error;
  }
  return res;
};

//----------------------------------------------------------------------------------------------------------------------
const importUsers = async (datas) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/users/setimportuser", datas);
  } catch (Error) {
    res = Error;
  }
  return res;
};
//----------------------------------------------------------------------------------------------------------------------
export { getUserxId, 
         getUsuarioFind, 
         getUserAll, 
         getPermisUserRuta, 
         getUserPermission, 
         setUserPermission, 
         getUserInt, 
         getFindUserParams, 
         getFindUserIdParams,
         ActualizaUser,
         ActualizaClave,
         getUserImport,
         getFindUserApi,
         importUsers };
